import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import UTF8 from './code/UTF8.js'
import { Axios, authorization, token } from '@/config'
import { SAVE_TOKEN, CLEAR_TOKEN } from '@/store/mutation-types'

// 设置基础路径、响应超时时间（秒）
axios.defaults.baseURL = Axios.baseURL + Axios.apiPath
axios.defaults.timeout = Axios.timeout
axios.defaults.withCredentials = Axios.withCredentials

// 请求拦截器
axios.interceptors.request.use(config => {
  // 补充认证
  if (localStorage.getItem('token')) {
    config.headers.Authorization = localStorage.getItem('token');
  }
  return config
})

let istoken = 1;
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 更新 token
    if (response.headers.authorization) {
      store.commit(SAVE_TOKEN, token(response.headers.authorization))
    }
    if(response.data.code == 111){
      localStorage.removeItem('token')
      if(istoken == 1){
        Vue.prototype.$message({
          message: response.data.msg,
          type: 'warning'
        })
      }
      istoken = 0;
      setTimeout(function(){
        window.location.href = "/login";
      },1000);
      return;
    } else if(response.data.code == 0){
      Vue.prototype.$message.error(response.data.msg);
    }else if(response.data.code == 400){
      Vue.prototype.$message.error(response.data.msg);
      store.commit(CLEAR_TOKEN)
      // router.replace({ name: 'login' })
      // window.location.href = "/login";
    }
    
    return response.data
    
  },
  error => {
    const response = error.response
    if (response) {
      error.config.url === 'logout' || Vue.prototype.$message.error(
        response.data || UTF8.decode(response.statusText)
      )

      // 权限异常，清除 token
      if (response.status === 401) {
        store.commit(CLEAR_TOKEN)
        // router.replace({ name: 'login' })
      }
    } else {
      Vue.prototype.$message.error('请求超时')
    }
  }
)

// 请求处理程序
const promiseHandle = (promise, resolve, reject) => {
  Axios.delay > 0 ?
    setTimeout(() => promise.then(response => resolve(response)).catch(error => reject(error)), Axios.delay) :
    promise.then(response => resolve(response)).catch(error => reject(error))
}

// GET 请求
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    promiseHandle(axios.get(url, { params }), resolve, reject)
  })
}

// POST 请求
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    promiseHandle(axios.post(url, data), resolve, reject)
  })
}

// DELETE 请求
export function deleted(url, params = {}) {
  return new Promise((resolve, reject) => {
    promiseHandle(axios.delete(url, { params }), resolve, reject)
  })
}

// PATCH 请求
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    promiseHandle(axios.patch(url, data), resolve, reject)
  })
}

// PUT 请求
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    promiseHandle(axios.put(url, data), resolve, reject)
  })
}
